export default __webpack_public_path__ + "static/media/tributos.df4838b1.png";